import { ApolloError, isApolloError } from '@apollo/client'
import { Alert, PrimaryButton } from '@designsforhealth/dfh-react-components'
import { GraphQLError } from 'graphql'
import { any, compose, test } from 'ramda'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import ErrorRetrievingDataMessage from '../../ErrorRetrievingDataMessage'
import TimeoutErrorMessage from '../../TimeoutErrorMessage'

const testTimeoutError = compose(
  test(/The OUT message was not received within/),
  (obj: GraphQLError) => obj.message,
)

const RetryButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
`

export interface QueryFallbackProps {
  buttonText?: React.ReactNode
  error: ApolloError | Error
  onRetry: () => void
}

const QueryFallback: React.FC<QueryFallbackProps> = ({ buttonText = 'Retry', error, onRetry }) => {
  const isTimeoutError = useMemo(
    () => isApolloError(error) && any(testTimeoutError, error.graphQLErrors),
    [error],
  )

  return (
    <>
      <Alert type="error">
        {isTimeoutError ? <TimeoutErrorMessage /> : <ErrorRetrievingDataMessage />}
      </Alert>
      <RetryButtonContainer>
        <PrimaryButton onClick={onRetry}>{buttonText}</PrimaryButton>
      </RetryButtonContainer>
    </>
  )
}

export default QueryFallback
